let body = document.querySelector("body"),
  productCheck = body.classList.contains("template-product"),
  collectionCheck = body.classList.contains("template-collection"),
  directoryLinks = document.querySelectorAll(".custom--directory-container"),
  careModal = document.getElementById("customer-care"),
  careLink = document.querySelector(".care-title"),
  filterCheck = document.querySelector("#CollectionFiltersForm") !== null,
  mobileCheck = window.innerWidth < 900,
  footerCheck = document.querySelector("footer") !== null;

const logs = true;

// if (careModal !== null) {
//   if (mobileCheck) {
//     careLink.textContent = "Help";
//   }
// }

// window.addEventListener("resize", function () {
//   if (careModal !== null) {
//     if (mobileCheck) {
//       careLink.textContent = "Help";
//     }
//   }
// });


function setHeaderMegaHeight() {
  // Set the height of the mega menu based on the header height
  if (document.querySelector("header.main-header") !== null) {    
  
    let headerHeight =
      document.querySelector("header.main-header").clientHeight;
    document.documentElement.style.setProperty( "--header-mega-height","".concat(headerHeight,"px"));

    if (logs) {
      console.log("Header height set to: " + headerHeight + "px");
    }
  } 
}
   


function infScroll(container, append) {
  var parent = container.parentNode;
  updateScrollPath(parent);

  let pagination = parent.querySelector(".pagination"),
    viewMore = document.querySelector(".view-more"),
    btt = document.querySelector(".btt-anchor"),
    filterCheck = parent.dataset.filter === "true";

  if (filterCheck) {
    path = parent.dataset.path + "&page={{#}}";
  } else {
    path = parent.dataset.path + "?page={{#}}";
  }

  if (pagination !== null) {
    // console.log("pagination exists");

    let infScrollActive = parent.getAttribute("data-scroll");

    if (infScrollActive === "true") {
      // console.log("infinite scroll active");

      let viewMoreText = viewMore.querySelector(".view-more__button");
      viewMore.classList.remove("visually-hidden"); // show view more button

      // console.log("display view more button");

      infiniteScroll = new InfiniteScroll(container, {
        // options
        hideNav: ".pagination",
        path: path,
        append: append,
        history: true,
        historyTitle: true,
        onInit: function () {
          this.on("load", function () {
            console.log("Infinite Scroll load");
          });
          this.on("request", function (path) {
            viewMoreText.textContent = "Loading…";
          });
          this.on("append", function (body, path, items, response) {
            if (btt !== null) {
              btt.classList.remove("visually-hidden");
              btt.classList.add("btt-active");
            }
            console.log("Infinite Scroll append path - " + path);
            // console.log("Infinite Scroll append length - " + items.length);
            // console.log("Infinite Scroll append response - " + response.status);

            viewMoreText.textContent = "View More";
          });
          this.on("error", function () {
            console.log("Infinite Scroll error");
          });
          this.on("last", function () {
            console.log("Infinite Scroll last");
          });
        },
      });
    } else {
      // console.log("infinite scroll disabled in settings");
      return;
    }
  } else {
    // console.log("no pagination");

    if (btt !== null) {
      btt.classList.add("visually-hidden");
      btt.classList.remove("btt-active");
    }
  }
}

function updateScrollPath(container) {
  // 1. run when filter is applied or on page load

  // console.log('updateScrollPath');

  if (!container) return; // Prevent errors if path element not found

  const filterUrl = window.location.href;
  const shopUrl = container.dataset.root;
  const afterDomain = filterUrl.split(".com");
  const path = afterDomain[1];

  // console.log('filterUrl', filterUrl);
  // console.log('shopUrl', shopUrl);
  // console.log('path', path);

  // check if url has active filter
  if (filterUrl.indexOf("?") === -1) {
    // No active filter found
    // console.log('No active filter found', filterUrl);
    container.dataset.filter = "false";
    return;
  } else {
    // console.log('Active filter found', path);
    // Active filter found
    container.dataset.path = path;
    container.dataset.filter = "true";
  }
}

function runScroll() {
  let latestProductGrid = document.querySelector(
    "#CollectionProductGrid .collection-list",
  );
  append = "li.collection-list__item";
  infScroll(latestProductGrid, append);
}
class CustomDirectory {
  constructor(target) {
    target.addEventListener("click", this.onDirectoryClick.bind(this));
  }

  onDirectoryClick(event) {
    const parentCheck = event.target.classList.contains("parent-link");

    if (!parentCheck) {
      console.log("normal link");
    } else {
      console.log("parent link");
      event.preventDefault();

      let parent = event.target.parentNode,
        container = parent.parentNode,
        child = container.querySelector(".custom--directory-child-wrap"),
        openClass = child.classList.contains("directory-open");

      const children = document.querySelectorAll(
        ".custom--directory-child-wrap",
      );

      if (window.innerWidth > 1024) {
        if (!openClass) {
          children.forEach((child) => {
            child.classList.add("directory-open");
          });
        } else {
          children.forEach((child) => {
            child.classList.remove("directory-open");
          });
        }
      } else {
        if (!openClass) {
          child.style.display = "block";
          child.classList.add("directory-open");
        } else {
          child.classList.remove("directory-open");
          child.style.display = "none";
        }
      }
    }
  }
}

const slider = document.querySelector(".custom__slider");

function desktopSlider(slider) {
  if (window.innerWidth > 1024) {
    new Flickity(slider, {
      // options
      cellAlign: "left",
      contain: true,
      cellSelector: ".custom__slide",
      setGallerySize: false,
      arrowShape:
        "M35.2836 13L0 49.9095L35.2836 86.819L39.3694 82.5436L11.2003 53.0708H100V46.7482L11.1982 46.7461L39.3694 17.2754L35.2836 13Z",
    });
  }
}

class CustomerCare {
  constructor(target) {
    target.addEventListener("click", this.onCareClick.bind(this));
  }

  onCareClick(event) {
    let careActive = document
        .querySelector("html")
        .classList.contains("care-active"),
      list = document.querySelector(".care-list"),
      careLink = document.querySelector("a.care-title");

    if (mobileCheck) {
      var span = careLink.querySelector("span.title.mobile");
      var title = span.dataset.title;
    } else {
      var span = careLink.querySelector("span.title.desktop");
      var title = span.dataset.title;
    }

    // event.target.classList.toggle("care-active");
    document.querySelector("html").classList.toggle("care-active");

    if (!careActive) {
      console.log("show " + span + " " + title);
      list.style.display = "flex";
      span.textContent = "×";
    } else {
      console.log("hide " + span + " " + title);
      list.style.display = "none";
      span.textContent = title;
    }
  }
}

window.addEventListener("click", function (e) {
  if (document.getElementById("customer-care").contains(e.target)) {
  } else {
    if (mobileCheck) {
      var title = careLink.dataset.mobileTitle;
      var span = careLink.querySelector("span.title.mobile");
    } else {
      var title = careLink.dataset.title;
      var span = careLink.querySelector("span.title.desktop");
    }

    document.querySelector("html").classList.remove("care-active");
    careLink.classList.remove("care-active");

    document.querySelector(".care-list").style.display = "none";
    span.textContent = title;
  }
});

function gorgiasReveal(link) {
  let htmlEl = document.querySelector("html");

  link.addEventListener("click", function (e) {
    htmlEl.classList.toggle("gorgias-active");

    let classCheck = htmlEl.classList.contains("gorgias-active");

    if (classCheck) {
      link.textContent = "Close Chat";
    } else {
      link.textContent = link.dataset.text;
    }
  });
}

class SortClick {
  constructor(target) {
    target.addEventListener("click", this.onSortClick.bind(this));
  }

  onSortClick(e) {
    let form = e.target.closest("form");
    // console.log('click ' + form)
    form.classList.toggle("sort-open");
  }
}

// if (filterCheck) {

//   new SortClick(document.querySelector('.sort-wrap button'))
// }

let chatLink = document.querySelector(".js-chat-link");

// Weird empty footer link fix :(

if (footerCheck) {
  // console.log('footer check')
  if (!mobileCheck) {
    // console.log('mobile check')
    let footer = document.querySelector("footer"),
      footerWrapChildren = footer.querySelectorAll(".footer-wrap--new a");

    footerWrapChildren.forEach((child) => {
      child.innerHTML.trim().length == 0
        ? child.remove()
        : console.log("removed empty footer link");
    });
  }
}

// Click to resume video

var mq = window.matchMedia("(max-width: 1024px)");
var mediaList = document.querySelector(".splide__list");

function videoObserver() {
  let slide = document.querySelector(".splide__slide"),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.play();
            // console.log('video play')
          } else {
            let video = entry.target.querySelector("video");
            if (video === null) {
              return;
            }
            video.pause();
            // console.log('video paused')
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      },
    );
  observer.observe(slide);
}

function onlyVariantImageLoad() {
  var variantImages = document.querySelectorAll("[data-variant-image]");
  var currentMedia = document.querySelector(".section--main-product").dataset
    .currentVariantMedia;
  let mobile = window.innerWidth < 1024;

  // console.log('hide images')

  variantImages.forEach((image) => {
    if (mobile) {
      if (image.dataset.mediaId != currentMedia) {
        image.classList.add("hidden-variant");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    } else {
      if (image.dataset.mediaId != currentMedia) {
        image.closest("li").classList.add("visually-hidden");
        image.closest("li").classList.remove("is-visible");
        image.closest("li").classList.remove("is-active");
        image.closest("li").classList.remove("splide__slide");
      }
    }
  });

  // console.log('images hidden')
}

if (productCheck) {
  let onlyCheck =
    document.querySelector(".section--main-product").dataset
      .variantImageBehaviour == "only";
  if (onlyCheck) {
    console.log("only variant image load");
    onlyVariantImageLoad();
  }
} else {
  if (logs) {
    console.log("all images load");
  }
}

// Megamenu

function megaMenu() {
  if (window.innerWidth > 1024) {
    let megaMenuLinks = document.querySelectorAll(
        ".header-main__nav__item--link--mega",
      ),
      regularLinks = document.querySelectorAll(".header-main__nav__item--link"),
      bannerSpacer = document.querySelector(".banner-sticky"),
      bannerSpacers = document.querySelectorAll(".banner-sticky"),
      annBar = document.querySelector("#shopify-section-announcement-bar");

    if (bannerSpacer !== null && annBar !== null) {
      if (logs) {
        console.log("banner spacer exists");
      }
      let scrollTimeout;

      window.addEventListener("scroll", () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollY = window.scrollY;
          const annBarHeight = annBar.offsetHeight;
           
          bannerSpacers.forEach((spacer) => {
            if (scrollY > annBarHeight) {
              // Scroll beyond annBar height - set banner spacer to 0
              spacer.style.height = "0px";
            } else {
              // Scroll within annBar height - restore banner spacer height
              spacer.style.height = `${annBarHeight}px`;
            }
          });
        }, 16); // Use 16ms for smoother animation (60fps)
      });
    }

  

    megaMenuLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();
      });

      link.addEventListener("mouseover", function (event) {
        // console.log("mouseover");

        let target = link.getAttribute("data-id"),
          targetEl = document.getElementById(target);

        if (targetEl != null) {
          let openMenus = document.querySelectorAll(".megamenu--active");
          openMenus.forEach((menu) => {
            menu.classList.remove("megamenu--active");
            menu.setAttribute("aria-hidden", true);
            menu.querySelector("a").setAttribute("aria-expanded", false);
          });
          targetEl.classList.add("megamenu--active");
          targetEl.setAttribute("aria-hidden", false);
          link.setAttribute("aria-expanded", true);
        }

        targetEl.addEventListener("mouseleave", function (event) {
          targetEl.classList.remove("megamenu--active");
          targetEl.setAttribute("aria-hidden", true);
          link.setAttribute("aria-expanded", false);
        });
      });
    });

    regularLinks.forEach((link) => {
      link.addEventListener("mouseover", function (event) {
        // console.log("mouseover regular link");
        let openMenus = document.querySelectorAll(".megamenu--active");
        openMenus.forEach((menu) => {
          menu.classList.remove("megamenu--active");
          menu.setAttribute("aria-hidden", true);
          menu.querySelector("a").setAttribute("aria-expanded", false);
        });
      });
    });

    if (Shopify.designMode) {
      console.log("Shopify design mode");

      function showMenu(event) {
        console.log(event.detail.sectionId);

        let target = event.detail.sectionId,
          targetEl = document.querySelector("#shopify-section-" + target);

        if (targetEl) {
          const targetMenu = targetEl.querySelector("section.megamenu");
          if (targetMenu) {
            targetMenu.classList.add("megamenu--active");
          } else {
            console.warn("No <section> found inside target element:", targetEl);
          }
        } else {
          console.warn("Target element not found for ID:", target);
        }
      }

      function hideMenu(event) {
        console.log(event.detail.sectionId);
        let target = event.detail.sectionId,
          targetEl = document.querySelector("#shopify-section-" + target);

        if (targetEl) {
          const targetMenu = targetEl.querySelector("section.megamenu");
          if (targetMenu) {
            targetMenu.classList.remove("megamenu--active");
          } else {
            console.warn("No <section> found inside target element:", targetEl);
          }
        } else {
          console.warn("Target element not found for ID:", target);
        }
      }

      document.addEventListener("shopify:section:select", function (event) {
        showMenu(event);
      });

      document.addEventListener("shopify:section:deselect", function (event) {
        hideMenu(event);
      });
    }
  }
}

directoryLinks.forEach((link) => {
  new CustomDirectory(link);
});
if (careLink !== null) {
  new CustomerCare(careLink);
}
setHeaderMegaHeight();

runScripts = function () {
  megaMenu();

  if (productCheck && mq.matches) {
    videoObserver();
  }

  if (collectionCheck) {
    runScroll();
  }
  if (chatLink !== null) {
    gorgiasReveal(chatLink);
  }
  if (
    productCheck &&
    document.querySelector(".section--main-product").dataset.slider === "true"
  ) {
    desktopSlider(slider);
  }
};

runScripts();

window.addEventListener("resize", function () {
  runScripts();
  setHeaderMegaHeight()
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    runScroll();
  });

  document.addEventListener("shopify:section:load", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:reorder", function (e) {
    let id = e.detail.sectionId;

    desktopSlider(slider);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    let id = e.detail.sectionId;
    desktopSlider(slider);
  });
}
